export default function MvpValorMercado() {
  return (
    <section id="mercado" className="py-20 bg-stone-50">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-8 h-8 rounded-lg bg-[#071210] flex items-center justify-center">
            <span className="text-emerald-400 text-xs font-bold">V</span>
          </div>
          <span className="text-stone-400 text-xs uppercase tracking-widest font-medium">Parte V</span>
        </div>
        <h2 className="text-3xl font-bold text-stone-900 mb-2">Aderência ao Valor de Mercado</h2>
        <p className="text-stone-500 mb-12 text-base">Os valores apresentados nesta proposta são consistentes com as referências praticadas no mercado de tecnologia em Manaus/AM e em âmbito nacional para projetos de inteligência artificial aplicada.</p>

        {/* Referências de projetos similares */}
        <div className="mb-10">
          <h3 className="text-base font-semibold text-stone-800 mb-2 flex items-center gap-2">
            <span className="w-6 h-6 rounded-md bg-stone-100 text-stone-700 text-xs font-bold flex items-center justify-center">5.1</span>
            Referências de Projetos de IA no Brasil — Mais Caros e com Menos Escopo (2024–2025)
          </h3>
          <p className="text-stone-400 text-sm mb-5">
            Os projetos abaixo foram contratados por valores iguais ou superiores ao desta proposta, porém com escopo significativamente menor — sem agentes autônomos, sem RAG, sem geração de documentos e sem ciclo end-to-end.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {[
              {
                tipo: 'Chatbot corporativo com IA generativa (setor financeiro)',
                escopo: 'Assistente conversacional para atendimento interno com base de conhecimento estática. Sem agentes autônomos, sem geração de documentos, sem integração com sistemas externos.',
                valor: 'R$ 380.000 a R$ 520.000',
                comp: 'Entrega ~15% do escopo da Fase 1',
                icon: 'ri-chat-3-line',
                badge: 'bg-red-100 text-red-700',
              },
              {
                tipo: 'Plataforma de análise de contratos com IA (setor jurídico)',
                escopo: 'Extração de cláusulas e alertas de risco em contratos PDF. Sem geração de texto, sem matching, sem pipeline de gestão e sem agentes especializados por categoria.',
                valor: 'R$ 420.000 a R$ 600.000',
                comp: 'Entrega ~20% do escopo da Fase 1',
                icon: 'ri-file-search-line',
                badge: 'bg-red-100 text-red-700',
              },
              {
                tipo: 'Sistema de triagem de currículos com IA (RH corporativo)',
                escopo: 'Classificação e ranqueamento de candidatos com base em critérios pré-definidos. Sem geração de conteúdo, sem base de conhecimento dinâmica e sem ciclo de autocrítica.',
                valor: 'R$ 290.000 a R$ 450.000',
                comp: 'Entrega ~10% do escopo da Fase 1',
                icon: 'ri-user-search-line',
                badge: 'bg-amber-100 text-amber-700',
              },
              {
                tipo: 'Dashboard de monitoramento regulatório com alertas (setor de saúde)',
                escopo: 'Rastreamento de publicações da ANVISA e alertas por e-mail. Sem análise estruturada por categorias, sem matching com portfólio e sem geração de documentos de resposta.',
                valor: 'R$ 310.000 a R$ 480.000',
                comp: 'Entrega ~25% do escopo da Fase 1',
                icon: 'ri-radar-line',
                badge: 'bg-amber-100 text-amber-700',
              },
            ].map((r) => (
              <div key={r.tipo} className="p-5 rounded-xl border border-stone-200 bg-white">
                <div className="flex items-start justify-between gap-3 mb-3">
                  <div className="w-8 h-8 rounded-lg bg-stone-100 flex items-center justify-center flex-shrink-0">
                    <i className={`${r.icon} text-stone-600 text-sm w-4 h-4 flex items-center justify-center`}></i>
                  </div>
                  <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap ${r.badge}`}>{r.comp}</span>
                </div>
                <p className="text-stone-800 text-sm font-semibold mb-1">{r.tipo}</p>
                <p className="text-stone-400 text-xs mb-3 leading-relaxed">{r.escopo}</p>
                <p className="text-stone-900 font-bold text-sm">{r.valor}</p>
              </div>
            ))}
          </div>
          <p className="mt-3 text-xs text-stone-400">Baseado em propostas comerciais públicas e licitações de TI em órgãos federais e estaduais entre 2024 e 2025 (SICONV, Portal Transparência e contratos publicados por universidades federais).</p>
        </div>

        {/* Justificativa */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <div className="p-6 rounded-2xl border border-emerald-200 bg-emerald-50">
            <h3 className="text-base font-semibold text-stone-800 mb-4 flex items-center gap-2">
              <i className="ri-shield-check-line text-emerald-600 text-sm w-4 h-4 flex items-center justify-center"></i>
              Por que os valores são justos
            </h3>
            <ul className="space-y-3">
              {[
                'Os valores praticados são 20% a 35% menores que os cobrados por equipes de São Paulo com o mesmo nível de especialidade',
                'O projeto envolve profissionais sênior com domínio de LLMs, agentes autônomos e sistemas de recuperação semântica — habilidades de alta raridade no mercado',
                'A composição da equipe é enxuta sem comprometer a qualidade de entrega, com especialistas de domínio validando as saídas da IA',
                'O prazo de 4 meses é agressivo para o escopo entregue, o que reflete a maturidade técnica da equipe e o reaproveitamento de componentes já desenvolvidos',
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-2">
                  <div className="w-3 h-3 mt-0.5 flex items-center justify-center flex-shrink-0">
                    <div className="w-1.5 h-1.5 rounded-full bg-emerald-500"></div>
                  </div>
                  <span className="text-stone-600 text-xs leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="p-6 rounded-2xl border border-amber-200 bg-amber-50">
            <h3 className="text-base font-semibold text-stone-800 mb-4 flex items-center gap-2">
              <i className="ri-line-chart-line text-amber-600 text-sm w-4 h-4 flex items-center justify-center"></i>
              O investimento da Fase 1 em perspectiva
            </h3>
            <div className="space-y-4">
              {[
                { label: 'Investimento total da Fase 1', value: 'R$ 357.000', sub: 'Desenvolvimento sob encomenda em 4 meses' },
                { label: 'Economia anual estimada em pessoal', value: 'até R$ 336.600/ano', sub: 'Redução de 3 a 4 analistas CLT para 1 analista de revisão' },
                { label: 'Payback da Fase 1', value: '~12,7 meses de uso', sub: 'Apenas pelo corte de custos operacionais, sem considerar receitas adicionais' },
                { label: 'Custo diário médio ao longo de 120 dias', value: 'R$ 2.975/dia', sub: 'Equivalente ao custo de 1 analista sênior em período integral' },
              ].map((item, i) => (
                <div key={i} className="flex items-start justify-between gap-3 p-3 rounded-lg bg-white border border-amber-100">
                  <div className="flex-1">
                    <p className="text-stone-500 text-xs">{item.label}</p>
                    <p className="text-xs text-stone-400 mt-0.5">{item.sub}</p>
                  </div>
                  <span className="text-stone-900 font-bold text-xs whitespace-nowrap">{item.value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
